import styled from 'styled-components'
import CLButton from 'syf-component-library/ui/atoms/Button/Button'
import query from 'syf-component-library/const/mediaQueries'
import { spacing } from 'syf-component-library/defaultTheme'

export const AddAccountButtonStyle = styled(CLButton)`
  margin: 0 0 0 ${spacing.base}px;
  height: auto;
  background-color: transparent;
  color: ${({ theme }) =>
    theme?.brandRefreshPhase >= 1
      ? 'var(--syfds-color-content-default)'
      : theme?.white};
  border-color: ${({ theme }) =>
    theme?.brandRefreshPhase >= 1
      ? 'var(--syfds-color-border-default)'
      : theme?.white};
  @media ${query.lessThanSmall} {
    margin: 0;
  }
  &:hover {
    color: ${({ theme }) => theme?.cyanBlue};
  }
`

export const AddAccountButtonIconWrapper = styled.div`
  margin: 0px;
`

export const AddAccountButtonWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4px;
`

export const AddAccountTextWrapper = styled.div`
  display: flex;
  text-align: left;
`
